import {
  IS_USER_FORCED_LOGOUT_RESPONSE,
  LOGIN_RESPONSE
} from "./types";

const INITIAL_STATE = {
  login:
    JSON.parse(localStorage.getItem("admin")) ||
    JSON.parse(sessionStorage.getItem("admin")) ||
    {},
  isUserForcedLogout: false
};

const auth = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_RESPONSE:
      return { ...state, login: action.payload };
    case IS_USER_FORCED_LOGOUT_RESPONSE:
      return {
        ...state,
        isUserForcedLogout: action.payload
      };
    default:
      return state;
  }
};

export default auth;
